<template>
  <div id="app">
    <keep-alive>
      <router-view
        v-wechat-title="$route.meta.title"
        v-if="$route.meta.keepAlive"
      ></router-view>
    </keep-alive>
    <router-view
      v-wechat-title="$route.meta.title"
      v-if="!$route.meta.keepAlive"
    ></router-view>
  </div>
</template>
<script>
import { isWEIXIN } from "./utils/publicMethods";
import Api from "./api/general-hospital/general-hospital";
const requestAuth = {
  jsApiList: [
    "getLocation",
    "scanQRCode",
    // 分享
    "updateAppMessageShareData",
    "updateTimelineShareData",
    //人脸
    "requestWxFacePictureVerify"
  ],
  openTagList: ["wx-open-launch-weapp"]
};
export default {
  data() {
    return {};
  },
  mounted() {
    console.log("isWEIXIN()=", isWEIXIN());
    if (isWEIXIN()) {
      if (window.location.host == "hlwyy.gyjkk.cn") {
        this.getWxConfigInfo();
      } else {
        //获取微信签名
        this.getJsapi();
      }
      try {
        this.prohibitAndroidAdjustmentSize();
      } catch (error) {}
      this.setMainShare();
    }
  },
  methods: {
    setMainShare() {
      wx.ready(function() {
        let imgUrl =
          "https://hlwyy.gyjkk.cn/ystresource/img/topic/20240911/20240911101910318_104.jpg";
        let title = "广元市互联网分院";
        wx.updateAppMessageShareData({
          title, // 分享标题
          desc: "分享给你的好友", // 分享描述
          link: location.origin, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl, // 分享图标
          success: function(res) {
            console.log("🚀 ~user wx.ready ~ res:", res);
          },
          fail(err) {
            console.log("🚀 ~user fail ~ err:", err);
          }
        });
        wx.updateTimelineShareData({
          title, // 分享标题
          link: location.origin, // 分享地址
          imgUrl, // 分享图标
          success: function(res) {
            console.log("🚀 ~friends wx.ready ~ res:", res);
          },
          fail(err) {
            console.log("🚀 ~friends fail ~ err:", err);
          }
        });
      });
    },
    //微信授权
    async getWxConfigInfo() {
      let _this = this;
      let myUrl = window.location.href;
      console.log("myUrl=", myUrl);
      await Api.getWxConfigInfo({ currentPageUrl: myUrl }).then(res => {
        console.log(res);
        if (res.result == "success") {
          // 先通过jsapi 获取 微信签名 等信息
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.noncestr,
            signature: res.signature,
            ...requestAuth
          });
          wx.ready(function() {
            console.log("ready success");
          });
          wx.error(function(res) {
            console.log("home.vue-error fail", res);
          });
        }
      });
    },
    //微信授权 义幻?
    getJsapi() {
      let _this = this;
      let myUrl = window.location.href;
      this.axios.post("/index/jsapi", { url: myUrl }, res => {
        if (res.code == 10000) {
          _this.myWxConfig = res.data;
          // 先通过jsapi 获取 微信签名 等信息
          wx.config({
            debug: false,
            appId: _this.myWxConfig.appId,
            timestamp: _this.myWxConfig.timestamp,
            nonceStr: _this.myWxConfig.nonceStr,
            signature: _this.myWxConfig.signature,
            ...requestAuth
          });
          wx.ready(function() {
            console.log("ready success");
          });
          wx.error(function(res) {
            console.log("home.vue-error fail", res);
          });
        } else {
          _this.weui.alert(res.message);
        }
      });
    },

    prohibitAndroidAdjustmentSize() {
      if (
        typeof WeixinJSBridge == "object" &&
        typeof WeixinJSBridge.invoke == "function"
      ) {
        this.handleFontSize();
      } else {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            this.handleFontSize,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.handleFontSize);
          document.attachEvent("onWeixinJSBridgeReady", this.handleFontSize);
        }
      }
    },

    handleFontSize() {
      // 设置网页字体为默认大小
      WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
      // 重写设置网页字体大小的事件
      WeixinJSBridge.on("menu:setfont", function() {
        WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
      });
    }
  }
};
</script>
<style>
@import url("./assets/css/base.css");
@import url("./assets/css/style.css");
@import url("./assets/css/flow-base.css");
@import url("./assets/css/general-hospital.css");
#app {
  font-family: "microsoft yahei", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}
</style>



// WEBPACK FOOTER //
// src/App.vue